import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Component } from 'react';

export const TIPO_CONFIRMACAO = {
    INCLUSAO: { id: 'INCLUSAO', cor: 'primary', icone: <AddCircleIcon /> },
    ATUALIZACAO: { id: 'ATUALIZACAO', cor: 'primary', icone: <SaveIcon /> },
    EXCLUSAO: { id: 'EXCLUSAO', cor: 'secondary', icone: <DeleteIcon /> }
};

class ModalConfirmacao extends Component {
    static textoPadraoConfirmacao = 'Sim';
    static textoPadraoCancelamento = 'Não';
    processando = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            processando: observable,
            iniciarProcessamento: action,
            finalizarProcessamento: action,
            confirmar: action,
            cancelar: action,
            fechar: action
        });
    }

    iniciarProcessamento() {
        this.processando = true;
    }

    finalizarProcessamento() {
        this.processando = false;
    }

    confirmar = async () => {
        this.iniciarProcessamento();

        try {
            await this.props.callbackConfirmar();
        } finally {
            this.finalizarProcessamento();
        }
    };

    cancelar = async () => {
        if (this.processando) {
            return;
        }

        await this.props.callbackCancelar();
    };

    fechar = async () => {
        if (this.processando) {
            return;
        }

        if (typeof this.props.callbackFechar === 'function') {
            await this.props.callbackFechar();
        } else {
            await this.props.callbackCancelar();
        }
    };

    get iconeBotaoConfirmacao() {
        let icone;

        if (this.props.iconeBotaoConfirmacao) {
            icone = this.props.iconeBotaoConfirmacao;
        } else if (this.props.tipoConfirmacao) {
            icone = this.props.tipoConfirmacao.icone;
        } else {
            icone = <ThumbUpAltIcon />;
        }

        return icone;
    }

    render() {
        return (
            <Dialog
                onClose={this.fechar}
                open={this.props.open}
                maxWidth={this.props.size ? this.props.size : 'sm'}
            >
                <DialogTitle sx={{ mt: 1 }}>
                    <Typography fontWeight={'bold'}>{this.props.titulo}</Typography>
                </DialogTitle>
                <DialogContent sx={{ m: 1 }}>
                    <>{this.props.children}</>
                </DialogContent>
                <DialogActions sx={{ mt: 2, ml: 3, mr: 3, mb: 2, justifyContent: 'space-between' }}>
                    <Button
                        color={'secondary'}
                        variant="outlined"
                        endIcon={<CancelIcon />}
                        onClick={this.cancelar}
                        disabled={this.processando}
                    >
                        <Typography>
                            {this.props.textoBotaoCancelamento
                                ? this.props.textoBotaoCancelamento
                                : ModalConfirmacao.textoPadraoCancelamento}
                        </Typography>
                    </Button>
                    <Button
                        color={this.props.tipoConfirmacao ? this.props.tipoConfirmacao.cor : 'primary'}
                        variant="contained"
                        endIcon={this.iconeBotaoConfirmacao}
                        onClick={this.confirmar}
                        loading={this.processando}
                        loadingPosition="end"
                    >
                        <Typography>
                            {this.props.textoBotaoConfirmacao
                                ? this.props.textoBotaoConfirmacao
                                : ModalConfirmacao.textoPadraoConfirmacao}
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

ModalConfirmacao.propTypes = {
    callbackConfirmar: PropTypes.func.isRequired,
    callbackCancelar: PropTypes.func.isRequired,
    callbackFechar: PropTypes.func,
    tipoConfirmacao: PropTypes.object,
    open: PropTypes.bool,
    titulo: PropTypes.string,
    children: PropTypes.node,
    textoBotaoConfirmacao: PropTypes.string,
    textoBotaoCancelamento: PropTypes.string,
    iconeBotaoConfirmacao: PropTypes.node,
    size: PropTypes.string
};

export default observer(ModalConfirmacao);
